import { makeStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles ((theme: Theme) => ({
	appBarSpacer: theme.mixins.toolbar
}));

/**
 * Spacing component for AppBar height.
 */
function AppBarSpacer () {
    const classes = useStyles ();
    
    return (
        <div className={classes.appBarSpacer}/>
    );
}

export default AppBarSpacer;
